'use client'

import type { ReactNode } from 'react'
import { SharedSurfaceProvider, type SharedSkin, type SharedSurface } from '@/deskUiSkeletons/Shared/SharedSurfaceContext'
import { MsgDeskLoading } from '../MsgDeskLoading'

const forumSharedSkin: SharedSkin = {
  navItem: 'group relative flex h-7 cursor-pointer items-center border border-[#006699] bg-[#eef3f8] px-2 text-[10px] font-bold text-[#006699] hover:bg-[#dfe6ef]',
  navItemSelected: 'bg-[#006699] text-white',
  navLabel: 'flex items-center',
  navLoading: 'animate-pulse',
  moreLink: 'mt-2 inline-block cursor-pointer border border-[#006699] bg-[#eef3f8] px-2 py-1 text-[10px] font-bold text-[#006699] hover:bg-[#dfe6ef]',
  testBadge: 'fixed right-2 top-10 z-[100000] border border-red-900 bg-red-700 px-2 py-1 text-[10px] font-bold text-white',
  testBadgeInfo: 'hidden',
  dialogBackdrop: 'hidden',
  dialogWindow: 'hidden',
  savingBackdrop: 'fixed inset-0 z-[100001] hidden bg-black/30',
  savingContent: 'fixed left-1/2 top-1/2 z-[100002] hidden -translate-x-1/2 -translate-y-1/2',
  msgBoxOverlay: 'fixed inset-0 z-[100003] hidden bg-white/75 text-center text-black',
  msgBoxSpacer: 'h-[40%]',
  msgBox: 'inline-flex max-w-full flex-col overflow-hidden border border-[#006699] bg-[#eef3f8] font-[Verdana,Arial,Helvetica,sans-serif] text-[11px]',
  msgBoxInfo: 'flex flex-col items-center p-3',
  msgBoxText: 'my-2',
  msgBoxPin: 'hidden',
  msgBoxCaptchaImg: 'block h-auto w-auto',
  msgBoxButtons: 'flex justify-center gap-1 border-t border-[#006699] bg-[#dfe6ef] p-2',
  msgBoxClose: 'cursor-pointer border border-[#006699] bg-[#eef3f8] px-2 py-1 font-bold text-[#006699]',
  msgBoxHiddenCancel: 'hidden',
  qrOverlay: 'fixed inset-0 z-[100000] flex items-center justify-center bg-black/35 p-4',
  qrInline: 'my-2 mx-2 max-w-[560px]',
  qrRoot: 'w-[min(523px,calc(100vw-32px))]',
  qrForm: 'block min-h-[180px] border border-[#006699] bg-[#eef3f8] p-2 font-[Verdana,Arial,Helvetica,sans-serif] text-[11px] text-black',
  qrEditForm: 'w-full',
  qrTextarea: 'block h-[130px] w-full border border-[#006699] bg-white p-2 text-[11px]',
  qrEmailLabel: 'block text-[10px]',
  qrCheckbox: 'mr-1',
  qrEmailLink: 'text-[10px] text-[#006699]',
  qrEmailValue: 'underline',
  qrActions: 'flex justify-end gap-1',
  qrSaveButton: 'border border-[#003f63] bg-[#006699] px-3 py-1 text-[10px] font-bold text-white',
  qrShadowRight: 'hidden',
  qrShadowBottom: 'hidden',
  pinOverlay: 'fixed inset-0 z-[100004] flex items-center justify-center bg-white/75 p-5 font-[Verdana,Arial,Helvetica,sans-serif] text-[11px] text-black',
  pinBox: 'flex w-[280px] max-w-full flex-col border border-[#006699] bg-[#eef3f8]',
  pinMessage: 'bg-[#006699] px-3 py-2 text-center font-bold text-white',
  pinInput: 'mx-3 my-3 border border-[#006699] bg-white p-1.5 text-[11px] text-black outline-none',
  pinActions: 'flex justify-end gap-1 border-t border-[#006699] bg-[#dfe6ef] p-2',
  pinButton: 'border border-[#006699] bg-[#eef3f8] px-2 py-1 text-[10px] font-bold text-[#006699]',
  pinButtonPrimary: 'border border-[#003f63] bg-[#006699] px-2 py-1 text-[10px] font-bold text-white',
}

const forumSharedSurface: SharedSurface = { Loading: MsgDeskLoading, skin: forumSharedSkin }

export function ForumSharedSurfaceProvider({ children }: { children: ReactNode }) {
  return <SharedSurfaceProvider value={forumSharedSurface}>{children}</SharedSurfaceProvider>
}
